
<div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
    <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
</div>
<div class="error-message">{{errorMessageFoxpost}}</div>
<iframe
frameborder="0"
loading="lazy"
src="https://cdn.foxpost.hu/apt-finder/v1/app/?discount=1"
width="100%"
height="800px"
></iframe>
